import { useState, useCallback, useEffect, useRef } from 'react';
import { Modal, message } from '@/components';
import { LegacyButtonType } from 'antd/lib/button/button';
import { useIntl } from 'umi';
import { useLocalStore } from 'mobx-react';
import { rtc } from '@/models';
import useBeforeUnload from '@/hooks/useBeforeUnload';
import { useDebounceEffect } from 'ahooks';
import { elkLog } from '@/utils/elkReport';

export default function useGlobalTips() {
  const isBeforeUnload = useBeforeUnload();
  const { RTCInstance } = useLocalStore(() => {
    return {
      RTCInstance: rtc,
    };
  });
  const { formatMessage } = useIntl();

  const modalrefreshRef = useRef<any>();
  // 浏览器限制自动播放，需要用户操作
  const dillAudioPlayErr = () => {
    Modal.warning({
      title: formatMessage({ id: 'MIC_INCOMPATIBLE' }),
      content: formatMessage({ id: 'MIC_CLICK_ABLE' }),
      okText: formatMessage({ id: 'CONFIRM' }),
      okButtonProps: {
        className: `popo-meeting-button`,
      },
      onOk() {
        [...RTCInstance.remoteStreamsMap.values()].forEach((stream: any) => {
          stream.play();
        });
        RTCInstance.setAudioPlayErr(false);
      },
    });
  };
  useEffect(() => {
    if (RTCInstance.audioPlayErr) {
      dillAudioPlayErr();
    }
  }, [RTCInstance.audioPlayErr]);

  useDebounceEffect(
    () => {
      // 进入会议后，isBeforeUnload 为 true 表示页面处于刷新中，不提示断网
      if (RTCInstance?.joined && RTCInstance?.disconnected && !isBeforeUnload) {
        modalrefreshRef.current = Modal.info({
          title: formatMessage({ id: 'NETWORK_FAILED_REFRESH' }),
          okText: formatMessage({ id: 'REFRESH' }),
          okButtonProps: {
            className: `btn-blue`,
          },
          onOk() {
            elkLog('网络连接失败刷新页面');
            history.go(0);
          },
        });
        elkLog('网络连接失败提示弹窗出现');
      }
    },
    [RTCInstance?.disconnected, RTCInstance?.joined, isBeforeUnload],
    { wait: 100 }
  );

  useEffect(() => {
    if (RTCInstance.curState === 'CONNECTED') {
      elkLog('网络连接失败提示弹窗在网络恢复后关闭');
      modalrefreshRef.current?.destroy();
    }
  }, [RTCInstance?.curState]);
}
